
import axios from 'axios';
import { BASE_URL } from './constants';
import Swal from 'sweetalert2';

export function PrintElem(content,width=900,height=500)
{
    var mywindow = window.open('', 'PRINT', `height=${height},width=${width}`);
    mywindow.document.write(content);
    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/
    mywindow.onafterprint = () => {
     
      //mywindow.close();
    };
    mywindow.print();

    return true;
}


const roundNumber =(number)=>{
    let modifiedNumber = number;
if(number % 1 != 0){
   modifiedNumber =parseFloat(number).toFixed(2)
}

   if(isNaN(modifiedNumber)){
return "NA"
   }else{
    return modifiedNumber
   }

}

export function PrintGrades(id, year_id) {
const URL = `${BASE_URL}/student/getcourses.php`;
axios.post(URL, { id: id, year_id: year_id }).then((res) => {
  
      if(res.data.data?.errorMsg){
        Swal.fire("" , res.data.data.data.errorMsg , "warning")
        return
      }
      
      PrintElem(res.data.data.data.report);
});
}

export function DateFormat(date){
    let options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'};
    let d = new Date(date);
    return d.toLocaleString('en-us',options)
}

export function getFormattedDate() {
    const date = new Date();

    let year = date.getFullYear();

    let month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    let day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    let hour = date.getHours().toString();
    hour = hour.length > 1 ? hour : '0' + hour;

    let minute = date.getMinutes().toString();
    minute = minute.length > 1 ? minute : '0' + minute;

    let second = date.getSeconds().toString();
    second = second.length > 1 ? second : '0' + second;

    return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
}
